import { useQuery } from "@tanstack/react-query"
import { getRfqBuyerToAdminStatusUpdates } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetRfqBuyerToAdminStatusUpdates(id: string) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["buyer-rfq-status-updates", id],
    queryFn: () => getRfqBuyerToAdminStatusUpdates(id, accessToken!),
    enabled: !!accessToken && !!id,
    staleTime: 5000, // keep for 5s
  })
}
